import React, {useEffect, useState, useContext} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {
    useForm,
    FormProvider,
    useFormContext,
    useWatch,
    UseFormReturn,
    FieldValues,
    UseFieldArrayReturn
} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiGridForm from "../components/Form/UiGridForm";
import UiInputList from "../components/Form/UiInputList";
import UiInputDate from "../components/Form/UiInputDate";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import UiInputMoney from "../components/Form/UiInputMoney";
import {KitDetail} from "./KitDetail";
import {get, getExtruturaList, getOrcamentoTipoCalculoList, post} from "../services/ApiService";
import VendedorForm from "./VendedorForm";
import AuthProvider from "../services/AuthProvider";
import UiInputTags from "../components/Form/UiInputTags";
import dayjs from "dayjs";

import {Toast} from "primereact/toast";
import Overlay from "../components/Overlay";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import ConsumoChart from "../components/Dashboard/ConsumoChart";

export const FormContext = React.createContext<any>({});

const estruturaListBase: any = getExtruturaList();
const estruturaList = Object.keys(estruturaListBase).map((key) => {
    return { id: key, title: estruturaListBase[key] };
})

const orcamentoTipoCalculoListBase: any = getOrcamentoTipoCalculoList();
const orcamentoTipoCalculoList = Object.keys(orcamentoTipoCalculoListBase).map((key) => {
    return { id: key, title: orcamentoTipoCalculoListBase[key] };
})

const incidenciaListBase: any = {
    "3.36": 'Leste / Oeste - 3.36',
    "3.80": 'Norte - 3.8',
    "2.5": 'Sul - 2.5',
};
const incidenciaList = Object.keys(incidenciaListBase).map((key) => {
    return { id: parseFloat(key).toFixed(2), title: incidenciaListBase[key] };
})

const coeficienteConsumoExtra = 1.10;

function ConsumoMedio({ consumoMedio, ...rest }: any) {
    return <div { ...rest }>
        <div className="consumo-medio">
            <span>Consumo médio: <b>{ Math.ceil(consumoMedio) }</b> kWh</span>
            <span>Recomendado kit com <b>{ Math.round(consumoMedio * coeficienteConsumoExtra) }</b> kWh de geração estimada</span>
        </div>
    </div>;
}

const doFetchConsumo = (uc: any, setValue: (value: any) => void) => {
    get(`/?route=celesc&action=consultaConsumo&pdf&payload=${JSON.stringify({
        nrUC: uc
    })}`)
        .then((response: any) => {
            if (response.status == 200) {
                const data = response.data;
                setValue(data);
            } else {
                alert('Falha ao carregar o consumo');
            }
        })
        .catch((err) => {
            alert('Falha ao carregar o consumo: ' + err);
        })
}

const UcInputWithLabel = ({ name, index, fieldsArray, ...rest }: any) => {
    const formContext = useFormContext();
    const { register, watch, setValue } = formContext;
    const isDisabled = watch(`${name}_disabled`);
    const ucValue = watch(name);

    // Quando o checkbox N/A é marcado/desmarcado, atualiza o valor do campo
    React.useEffect(() => {
        if (isDisabled) {
            // Checkbox marcado - seta valor como "UNIDADE NÃO INFORMADA"
            setValue(name, 'UNIDADE NÃO INFORMADA');
        } else {
            // Checkbox desmarcado - limpa o valor se era "UNIDADE NÃO INFORMADA"
            if (ucValue === 'UNIDADE NÃO INFORMADA') {
                setValue(name, '');
            }
        }
    }, [isDisabled]);

    const handleBeneficiariaClick = () => {
        if (window.confirm('Deseja tornar esta unidade a geradora?')) {
            fieldsArray.move(index, 0);
        }
    };

    return (
        <div className="col-lg-2">
            <div className="form-item">
                <label className="form-label">
                    Unidade Consumidora
                    {ucValue && (
                        <a className="link-element" href={`https://api.argonsolar.com.br/?route=celesc&action=consultaFaturaListHtml&pdf&payload=${JSON.stringify({ nrUC: ucValue })}`} target="_blank">
                            Faturas
                        </a>
                    )}
                </label>
                <div className="field-container" style={{ display: 'flex' }}>
                    {/* Label Geradora/Beneficiária à esquerda */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #CCC',
                        borderRight: 0,
                        borderRadius: '5px 0 0 5px',
                        padding: '0 8px',
                        background: index === 0 ? '#d4edda' : '#fff3cd',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        color: index === 0 ? '#155724' : '#856404',
                        minWidth: '80px',
                        cursor: index === 0 ? 'default' : 'pointer',
                        userSelect: 'none'
                    }}
                    onClick={index === 0 ? undefined : handleBeneficiariaClick}
                    title={index === 0 ? 'Unidade Geradora' : 'Clique para tornar geradora'}
                    >
                        {index === 0 ? 'Geradora' : 'Beneficiária'}
                    </div>

                    {/* Input UC */}
                    <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        style={{ flex: 1, borderRadius: 0, borderLeft: 0, borderRight: 0 }}
                        {...register(name)}
                        {...rest}
                    />

                    {/* Checkbox N/A à direita */}
                    <label className="form-append" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',
                        cursor: 'pointer',
                        border: '1px solid #CCC',
                        borderLeft: 0,
                        borderRadius: '0 5px 5px 0',
                        padding: '0 8px',
                        background: '#EEE',
                        fontSize: '11px'
                    }}>
                        <input type="checkbox" className="form-check-input" style={{ margin: 0 }} {...register(`${name}_disabled`)} />
                        N/A
                    </label>
                </div>
            </div>
        </div>
    );
};

const UcLinkComponent = (props: any) => {
    const { watch, getValues } = props.formContext;

    const thisData = getValues(props.name);

    return <>
        {
            thisData &&
            <a className="link-element" href={`https://api.argonsolar.com.br/?route=celesc&action=consultaFaturaListHtml&pdf&payload=${JSON.stringify({
                nrUC: thisData
            })}`} target="_blank">Faturas</a>
        }
    </>
}

const ConsumoChartWrapper = ({ name }: { name: string }) => {
    const { watch } = useFormContext();

    // Extrai o base path (ex: "ucList.0.chart" -> "ucList.0")
    const basePath = name.split('.').slice(0, -1).join('.');

    // Watch para reagir a mudanças
    const consumo = watch(`${basePath}.consumo`) || '';
    const dataInicial = watch(`${basePath}.dataInicial`) || '';

    return (
        <div className="col-lg-2">
            <ConsumoChart consumo={consumo} dataInicial={dataInicial} />
        </div>
    );
};

const PercentualSobraWrapper = ({ name }: { name: string }) => {
    const { watch } = useFormContext();

    // Extrai o base path e índice
    const basePath = name.split('.').slice(0, -1).join('.');
    const index = parseInt(name.split('.')[1]);

    // Watch o consumo diretamente e calcula em tempo real
    const consumoStr = watch(`${basePath}.consumo`) || '';
    const ucList = watch('ucList') || [];

    // Calcular consumo médio diretamente
    let consumoMedio = 0;
    if (consumoStr) {
        const consumo = consumoStr.split(',').filter((n: any) => n && n.trim() !== '');
        if (consumo.length > 0) {
            const sum = consumo.reduce((a: any, b: any) => parseFloat(a) + parseFloat(b), 0);
            consumoMedio = sum / consumo.length;
        }
    }

    // Calcular totais para porcentagens
    let totalConsumo = 0;
    let totalSemGeradora = 0;
    ucList.forEach((item: any, idx: number) => {
        if (item?.consumo) {
            const consumo = item.consumo.split(',').filter((n: any) => n && n.trim() !== '');
            if (consumo.length > 0) {
                const sum = consumo.reduce((a: any, b: any) => parseFloat(a) + parseFloat(b), 0);
                const avg = sum / consumo.length;
                totalConsumo += avg;
                if (idx > 0) totalSemGeradora += avg;
            }
        }
    });

    const porcentagemGeral = totalConsumo > 0 ? consumoMedio / totalConsumo : 0;
    const porcentagemSobra = (totalSemGeradora > 0 && index > 0) ? consumoMedio / totalSemGeradora : 0;

    return (
        <div className="col-lg-3">
            <div style={{
                height: '73px',
                width: '100%',
                border: '1px solid #EEE',
                borderRadius: '4px',
                background: '#F0F0F0',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around',
                padding: '10px',
                gap: '8px'
            }}>
                {/* Média de consumo */}
                {consumoMedio > 0 && (
                    <div style={{
                        textAlign: 'center',
                        flex: 1,
                        borderRight: porcentagemGeral > 0 ? '1px solid #DDD' : 'none',
                        paddingRight: porcentagemGeral > 0 ? '8px' : '0'
                    }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                            {Math.ceil(consumoMedio)}
                        </div>
                        <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>kWh médio</div>
                    </div>
                )}

                {/* Porcentagem geral */}
                {porcentagemGeral > 0 && (
                    <div style={{
                        textAlign: 'center',
                        flex: 1,
                        borderRight: porcentagemSobra > 0 ? '1px solid #DDD' : 'none',
                        paddingRight: porcentagemSobra > 0 ? '8px' : '0'
                    }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                            {(porcentagemGeral * 100).toFixed(1)}%
                        </div>
                        <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>média geral</div>
                    </div>
                )}

                {/* Porcentagem sem geradora */}
                {porcentagemSobra > 0 && (
                    <div style={{ textAlign: 'center', flex: 1 }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#007bff' }}>
                            {(porcentagemSobra * 100).toFixed(1)}%
                        </div>
                        <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>do excedente</div>
                    </div>
                )}
            </div>
        </div>
    );
};

const ConsumoLinkComponent = (props: any) => {
    const { getValues, setValue } = props.formContext;
    const base = props.name.split('.').slice(0, -1).join('.');
    const uc = getValues(base + '.uc');
    const [ isLoading, setIsLoading ] = useState(false);

    return <>
        {
            uc &&
            <a className="link-element" href="#" onClick={() => {
                setIsLoading(true);
                doFetchConsumo(uc, (value) => {
                    setIsLoading(false);
                    setValue(base + '.dataInicial', value?.dataInicial);
                    setValue(props.name, value?.consumo);
                })
            }}>{ isLoading ? `Carregando...` : `Carregar da Celesc` }</a>
        }
    </>
}

// export function AbstractForm(props: any){
//     const { setShowForm, doRefreshGrid, children } = props;
//     const [loading, setLoading] = useState(false);
//
//     const toastAlert = (payload: any) => {
//         // @ts-ignore
//         toast && toast.current && toast.current.show(payload);
//     }
//
//     const triggerSubmit = (data: any) => {
//         setLoading(true);
//         post(`/?route=${props.router}/form&action=${action}`, {dados: data})
//             .then((response: any) => {
//                 if (response.status == 200) {
//                     if (response.data.success) {
//                         setShowForm(false);
//                         doRefreshGrid();
//                         toastAlert({
//                             severity: 'success',
//                             summary: 'Sucesso!',
//                             detail: response.data.message,
//                             life: 3000
//                         });
//                     }else{
//                         return Promise.reject(response.data.message);
//                     }
//                 } else {
//                     return Promise.reject('Falha ao carregar');
//                 }
//             })
//             .catch((err: any) => {
//                 toastAlert({
//                     severity: 'error',
//                     summary: 'Erro!',
//                     detail: err,
//                     life: 3000
//                 });
//             })
//             .finally(() => setLoading(false))
//     }
//     const triggerSubmitAsNew = (data: any) => {
//         //console.log(data);
//         setLoading(true);
//         post(`/?route=${props.router}/form&action=add`, {dados: data})
//             .then((response: any) => {
//                 if (response.status == 200) {
//                     if (response.data.success) {
//                         setShowForm(false);
//                         triggerRefreshGrid();
//                         toastAlert({
//                             severity: 'success',
//                             summary: 'Sucesso!',
//                             detail: response.data.message,
//                             life: 3000
//                         });
//                     }else{
//                         return Promise.reject(response.data.message);
//                     }
//                 } else {
//                     return Promise.reject('Falha ao carregar');
//                 }
//             })
//             .catch((err: any) => {
//                 toastAlert({
//                     severity: 'error',
//                     summary: 'Erro!',
//                     detail: err,
//                     life: 3000
//                 });
//             })
//             .finally(() => setLoading(false))
//     }
//
//     return <>
//         <Toast ref={toast} />
//         <Overlay show={loading} />
//         {children}
//     </>
// }

const UcWarningComponent = (props: any) => {
    const { ucConflicts, name, formContext } = props;
    // Extrai o índice do nome do campo (ex: "ucList.0.uc" => índice 0)
    const indexMatch = name.match(/\.(\d+)\./);
    const index = indexMatch ? parseInt(indexMatch[1]) : -1;
    const conflicts = ucConflicts[index];

    // Pega o valor da UC do formulário
    const ucValue = formContext?.watch(name) || '';

    if (!conflicts || conflicts.length === 0) {
        return null;
    }

    const formatCurrency = (value: any) => {
        if (!value) return 'N/A';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(parseFloat(value));
    };

    return (
        <div className="uc-warning" style={{
            width: '100%',
            marginTop: '10px',
            marginBottom: '5px',
            padding: '12px 15px',
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '4px',
            fontSize: '13px',
            color: '#856404'
        }}>
            <div style={{ marginBottom: '8px' }}>
                <strong style={{ fontSize: '14px' }}>⚠️ Atenção:</strong> A unidade consumidora <strong>{ucValue}</strong> já possui orçamento(s) de outro(s) vendedor(es):
            </div>
            <ul style={{ margin: '0', paddingLeft: '20px', listStyleType: 'disc' }}>
                {conflicts.map((conflict: any, idx: number) => (
                    <li key={idx} style={{ marginBottom: '6px', lineHeight: '1.6' }}>
                        <div>
                            <strong>Orçamento #{conflict.orc_id}</strong> {' | '}
                            Vendedor: <strong>{conflict.vendedor_nome}</strong> {' | '}
                            Cliente: <strong>{conflict.cliente_nome}</strong>
                        </div>
                        <div style={{ marginTop: '2px' }}>
                            Valor: <strong>{formatCurrency(conflict.kit_preco_venda)}</strong> {' | '}
                            {conflict.kit_referencia && (<>Kit: <strong>{conflict.kit_referencia}</strong> {' | '}</>)}
                            Data: <strong>{new Date(conflict.orc_data_hora).toLocaleDateString('pt-BR')}</strong>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default function OrcamentoForm(props: any){
    const { user } = useContext<any>(AuthProvider);
    const [ucConflicts, setUcConflicts] = useState<any>({});

    const verificarUcDuplicada = async (uc: string, index: number, vendedorId: any, orcamentoId: any) => {
        if (!uc || uc === '' || uc === 'UNIDADE NÃO INFORMADA') {
            // Limpa conflitos se UC foi removida ou é N/A
            setUcConflicts((prev: any) => {
                const newConflicts = { ...prev };
                delete newConflicts[index];
                return newConflicts;
            });
            return;
        }

        try {
            const response = await get(`/?route=orcamento/form&action=verificarUcDuplicada&uc=${encodeURIComponent(uc)}&vendedor_id=${vendedorId || ''}&orcamento_id=${orcamentoId || ''}`);

            if (response.status === 200 && response.data.success) {
                setUcConflicts((prev: any) => ({
                    ...prev,
                    [index]: response.data.conflicts || []
                }));
            }
        } catch (error) {
            console.error('Erro ao verificar UC duplicada:', error);
        }
    };

    if(props.data && props.data.ucList){
        if(!Array.isArray(props.data.ucList)) {
            var newList = Object.keys(props.data.ucList).map((itemIndex) => {
                let item = props.data.ucList[itemIndex];
                if (!item.uc) {
                    item.uc = itemIndex;
                    let firstDate: any = null;
                    let newConsumoList: any = [];
                    Object.keys(item.consumo).map((consumoDate: any) => {
                        const consumoItem = item.consumo[consumoDate];
                        if (!firstDate) {
                            firstDate = consumoDate;
                        }
                        newConsumoList.push(consumoItem);
                    })
                    item.dataInicial = firstDate.substring(5, 7) + '/' + firstDate.substring(0, 4);
                    item.consumo = newConsumoList.join(',')
                }
                return item;
            });
            props.data.ucList = newList;
        }
    }

    if(props.data){
        if(!props.data.precoVendaBase){
            props.data.precoVendaBase = props.data.precoVenda;
        }
        if(!props.data.descontoVendedor){
            props.data.descontoVendedor = 0;
        }
    }

    const formDefaults = { tipo: 1, tipoCalculo: 1, incidenciaSolar: 3.36, descontoVendedor: 0, estrutura: 120 };
    const methods = useForm({
        defaultValues: props.data ? { ...formDefaults, ...props.data } : formDefaults,
    });
    const { handleSubmit, watch, control, setValue, reset } = methods;

    // Atualiza o form quando os dados chegam (para edição)
    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);
    const ligacaoList = [
        { id: 1, title: 'Monofasica' },
        { id: 2, title: 'Bifasica' },
        { id: 3, title: 'Trifasica' },
    ];
    const allData = watch();
    const onSelectKit = (data: any) => {
        console.log(data);
        if(data){
            if(!allData.precoVendaBase || allData.precoVendaBase == '' || allData.precoVendaBase < 1){
            //if(!allData.precoVendaBase || confirm('Definir preço sugerido?')){

                let precoSugerido = data.preco_venda;
                let milhares = Math.round(precoSugerido / 1000) * 1000;
                let centenas = precoSugerido - milhares;
                if(centenas > 600){
                    centenas = 900;
                }else if(centenas > 400 && centenas < 600){
                    centenas = 500;
                }else{
                    centenas = 900;
                    milhares = milhares - 1000;
                }
                precoSugerido = milhares + centenas;

                setValue('precoVendaBase', precoSugerido);
                setValue('descontoVendedor', 0);
            }
            if(data.kit_estrutura){
                setValue('estrutura', data.kit_estrutura);
            }
        }
    }

    const ucList = useWatch({
        control,
        name: "ucList",
    });

    // const descontoVendedor = watch('descontoVendedor');
    // useEffect(() => {
    //     if(allData.precoVendaBase && allData.descontoVendedor !== null) {
    //         setValue('precoVenda', allData.precoVendaBase - allData.descontoVendedor);
    //     }
    // }, [descontoVendedor])

    const precoVendaBase = watch('precoVendaBase');
    useEffect(() => {
        if(allData.precoVendaBase) {
            setValue('precoVenda', (allData.precoVendaBase ?? 0)); // - (allData.descontoVendedor ?? 0)
            setValue('precoVenda', (allData.precoVendaBase ?? 0)); // - (allData.descontoVendedor ?? 0)
        }

        if(allData.kit?.estrutura && !allData.estrutura) {
            setValue('estrutura', allData.kit.estrutura);
        }
    }, [precoVendaBase])

    let consumoMedio = 0;
    let consumoMedioSemGeradora = 0;
    if(ucList && Array.isArray(ucList)) {
        try {
            ucList.map((item: any, index) => {
                if (item.consumo) {
                    const consumo = item.consumo.split(',').filter((n: any) => n);
                    const sum = consumo.reduce((a: any, b: any) => (a * 1) + (b * 1), 0);
                    const avg = (sum / consumo.length) || 0;
                    item.consumoMedio = avg;
                    consumoMedio += avg;
                    if(index > 0) {
                        consumoMedioSemGeradora += avg;
                    }
                }else{
                    item.consumoMedio = 0;
                    item.porcentagemGeral = 0;
                    item.porcentagemSobra = 0;
                }
                if(!item.dataInicial){
                    setValue('ucList.' + index + '.dataInicial', dayjs().format('DD/MM/YYYY'))
                }
            });
            consumoMedio = (consumoMedio);
            consumoMedioSemGeradora = (consumoMedioSemGeradora);

            ucList.map((item: any, index) => {
                if (item.consumoMedio) {
                    item.porcentagemGeral = (item.consumoMedio / consumoMedio);
                    item.porcentagemSobra = 0;
                    if(consumoMedioSemGeradora > 0 && index > 0) {
                        item.porcentagemSobra = (item.consumoMedio / consumoMedioSemGeradora);
                    }
                }
            });
        } catch (err) {}
    }

    // Enquanto carrega, exibe apenas o Overlay
    if (props.loading) {
        return <Overlay show={true} />;
    }

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <WindowBody>
                        {/*<pre>{ JSON.stringify(allData, null, 2) }</pre>*/}
                        <div className="row">
                            <UiInputList size={2} name="tipoCalculo" list={orcamentoTipoCalculoList} idField="id" titleField="title" label="Tipo de Orçamento" />
                            <UiInputSuggest size={3} router="vendedor" idField="id" titleField="nome" name="vendedor" label="Vendedor" formComponent={VendedorForm}/>
                            <UiInputSuggest size={3} router="cliente" idField="id" titleField="nome" name="cliente" label="Cliente"/>
                            <UiInputList size={2} name="estrutura" list={estruturaList} idField="id" titleField="title" label="Estrutura" />
                            {/*<UiInputSuggest size={3} router="tag" idField="id" titleField="titulo" name="tag" label="Tags" formComponent={VendedorForm}/>*/}
                            <UiInputTags size={2} name="tag" label="Tags" tipo={2} allowCreate={false}/>
                        </div>

                        <UiGridForm name="ucList" label="Unidades" extraElements={(
                            placeholder: string,
                            formContext: UseFormReturn<FieldValues, any>,
                            index: number,
                            fieldsArray: UseFieldArrayReturn<FieldValues, any, "id">
                        ) => {
                                let returnElements = [];

                                // Adiciona o componente de warning se existir conflito
                                const conflicts = ucConflicts[index];
                                if (conflicts && conflicts.length > 0) {
                                    returnElements.push(
                                        <UcWarningComponent key={`warning-${index}`} ucConflicts={ucConflicts} name={`ucList.${index}.uc`} formContext={formContext} />
                                    );
                                }

                                return returnElements;
                            }
                        }>
                            <UcInputWithLabel
                                name="uc"
                                onBlur={(e: any) => {
                                    const fieldName = e.target.name;
                                    const indexMatch = fieldName.match(/\.(\d+)\./);
                                    if (indexMatch) {
                                        const index = parseInt(indexMatch[1]);
                                        const ucValue = e.target.value;
                                        const vendedorId = allData?.vendedor?.id;
                                        const orcamentoId = allData?.id;
                                        verificarUcDuplicada(ucValue, index, vendedorId, orcamentoId);
                                    }
                                }}
                            />
                            <UiInputList size={1} name="ligacao" list={ligacaoList} idField="id" titleField="title" label="Ligação" />
                            {/*<UiInputText size={3} name="cpfCnpj" label="CPF/CNPJ"/>*/}
                            {/*<UiInputText size={3} name="extras" label="Extras"/>*/}

                            <UiInputDate view="month"
                                         dateFormat="mm/yy"
                                         yearRange="2018:2030" size={1} name="dataInicial" label="Data Inicial"/>

                            <UiInputTextarea linkComponent={ConsumoLinkComponent} size={3} name="consumo" label={`Consumo`} onKeyPress={(e: any) => {
                                if(e.key === 'Enter')
                                    e.preventDefault()
                            }}/>

                            <ConsumoChartWrapper name="chart" />
                            <PercentualSobraWrapper name="percentual" />
                        </UiGridForm>

                        <div className="row">
                            <ConsumoMedio className="col-sm-12 consumo-medio-container" consumoMedio={consumoMedio} />
                            <UiInputList size={2} name="incidenciaSolar" list={incidenciaList} idField="id" titleField="title" label="Orientação" />
                            <UiInputSuggest size={4}
                                            initialFilter={{
                                                geracao_garantida: {
                                                    type: 'greaterThan',
                                                    filter: Math.round(consumoMedio * coeficienteConsumoExtra)
                                                },
                                                kit_estrutura: {
                                                    type: 'equals',
                                                    filter: String(allData.estrutura)
                                                },
                                                kit_disponivel: {
                                                    type: 'equals',
                                                    filter: '1'
                                                },
                                                kit_inversor: { type: 'equals', filter: '' },
                                                kit_numero_placas: { type: 'equals', filter: '' },
                                                referencia: { type: 'contains', filter: '' },
                                            }}
                                            extraData={{
                                                incidenciaSolar: allData?.incidenciaSolar ?? 3.8,
                                                consumoMedio: consumoMedio
                                            }}
                                            onSelect={onSelectKit} router="kit" idField="id" titleField="referencia" name="kit" label="Kit"/>

                            <UiInputMoney size={2} readOnly={![1, 4].includes(user.acesso)} name="precoVendaBase" label="Preço base"/>
                            <UiInputMoney size={2} name="descontoVendedor" label="Desconto do Vendedor"/>
                            <UiInputMoney size={2} readOnly={true} name="precoVenda" label="Preço de Venda"/>

                        </div>
                        { allData?.kit?.id && <>
                            <KitDetail consumoMedio={consumoMedio} kit={allData.kit} descontoVendedor={allData.descontoVendedor} precoVenda={allData.precoVendaBase} data={allData} />
                        </> }

                        <hr />

                        <div className="row">
                            <UiInputCheckbox size={3} name="config.incluirRoi" label="Incluir Estudo de ROI"/>
                            <UiInputCheckbox size={3} name="config.incluirEx" label="Incluir dados de Ex Tarifário"/>
                            <UiInputCheckbox size={3} name="config.separarValores" label="Separar valores do kit e mão de obra"/>
                            <UiInputCheckbox size={3} name="config.removerSimulacoes" label="Remover simulações"/>
                        </div>

                        {/*<pre>{JSON.stringify(allData.config, null, 2)}</pre>*/}
                    </WindowBody>

                    <WindowFooter>
                        {/*<UiInputCheckbox size={2} name="config.extTarifario" label="Exibir observação do "/>*/}
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                        <UiButton type="button" variant="primary" onClick={() => { props.triggerSubmitAsNew(allData) }}>Salvar como novo</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}